import { DeviceUUID } from 'device-uuid';

const useDeviceUUID = (): string => {
  return new DeviceUUID().get();
};

export default useDeviceUUID;
